import { EReservations } from '@enums/api.enum';
import type { Reservation } from '@store/trips/tripsSlice';

import client from '../apiClient';

export type ReservationParam = {
	id: Reservation['id'];
};

export interface ReservationApiResponse extends Reservation {
	metadata?: {
		icabbiTrackingUrl?: string;
	};
}

const endpoint = EReservations.endpoint;

const getSingle = <T>({ id }: ReservationParam) => client.get<T>(`${endpoint}${EReservations.single}${id}`);

export default {
	getSingle,
};
